@if (isContractCreated === true) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }
  <div class="contract-created-card">
    <div class="contract-created-content">
      <h1>{{ 'TRANSLATE.CONGRATULATIONS' | translate }}</h1>
      <h3>
        {{ 'TRANSLATE.YOU.HAVE.JUST.PURCHASED.FORD.PROTECT' | translate }}
      </h3>
      <h3>
        {{ 'TRANSLATE.NEXT.YOU.CAN.ACCESS.CONTRACT.TEXT' | translate }}
      </h3>
      <h3>
        {{ 'TRANSLATE.THANK.YOU.AND.COUNT.ON.US' | translate }}
      </h3>
    </div>
    <div class="col-12 md:col-12 lg:col-12 button-position contract-created-action">
      <button id="btnDownload" class="btn-download contract-created-download" type="button"
        [disabled]="isDownloadingContract" [ngClass]="{ 'is-loading': isDownloadingContract }"
        [attr.aria-busy]="isDownloadingContract" (click)="downloadPDF()">
        @if (!isDownloadingContract) {
        <i class="pi pi-download" aria-hidden="true"></i>
        }
        @if (isDownloadingContract) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="btn-download-span">
          {{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' :
          'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
}

@if (isContractCreated === false) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }
  <div class="contract-wrapper">
    <div class="col-11 md:col-11 lg:col-10 page-content">
      <div class="col-12 md:col-11 lg:col-10 image-position">
        <img class="ford-protect-logo" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="Ford Protect">
      </div>
      <div class="col-12 md:col-12 lg:col-12 contract-title">
        @if (verifyingOverTwelveMonths) {
        <h3 class="col-12 md:col-11 lg:col-10">
          TÉRMINOS Y CONDICIONES SERVICIO FORD PROTECT - VEHICULOS USADOS DENTRO DEL PERIODO DE GARANTIA
        </h3>
        }
        @if (!verifyingOverTwelveMonths) {
        <h3 class="col-12 md:col-12 lg:col-12">
          TÉRMINOS Y CONDICIONES SERVICIO FORD PROTECT - VEHICULOS 0 KM
        </h3>
        }
      </div>
      <div class="contract-information">
        <h4 class="contract-information-title">DATOS DEL CLIENTE:</h4>
        <div class="contract-information-items">
          <p>Nombre y Apellido / Razón Social:</p> <span>{{ completeName }} </span>
        </div>
        <div class="contract-information-items">
          <p>DNI/CUIT:</p> <span>{{ clientData.nationalId || '-' }} </span>
        </div>
      </div>
      <div class="contract-information">
        <h4 class="contract-information-title">DATOS DEL VEHÍCULO:</h4>
        <div class="contract-information-items">
          <p>Modelo:</p> <span>{{ vinValidate.modelName.toUpperCase() }} </span>
        </div>
        <div class="contract-information-items">
          <p>VIN:</p> <span>{{ vinValidate.vin }} </span>
        </div>
        <div class="contract-information-items">
          <p>Año:</p> <span>{{ vinValidate.modelYear }} </span>
        </div>
        @if (verifyingOverTwelveMonths) {
        <div class="contract-information-items">
          <p>Fecha de entrega del Vehiculo:</p> <span>{{ vinValidate.warrantyStartDate ?
            (vinValidate.warrantyStartDate | date: "dd/MM/yyyy") : "" }} </span>
        </div>
        }
        @if (verifyingOverTwelveMonths) {
        <div class="contract-information-items">
          <p>Kilometraje:</p> <span>{{ vinValidate.odometro }} </span>
        </div>
        }
      </div>
      <div class="contract-information">
        <h4 class="contract-information-title">SERVICIO FORD PROTECT</h4>
        <div class="contract-information-items">
          <p>Código Plan:</p>
          <span>
            {{
            (extensionProduct ? extensionProduct : "") +
            (extensionProduct && maintenanceProduct ? ", " : "") +
            (maintenanceProduct ? maintenanceProduct : "") +
            ((extensionProduct || maintenanceProduct) && partProduct? ", " : "") +
            (partProduct? partProduct: "")
            }}
          </span>
        </div>
        <div class="contract-information-items">
          <p>Descripción:</p>
          <span>{{
            (extensionDescription ? extensionDescription : "") +
            (extensionDescription && maintenanceDescription ? ", " : "") +
            (maintenanceDescription ? maintenanceDescription : "") +
            ((extensionDescription || maintenanceDescription) && partDescription? ", " : "") +
            (partDescription? partDescription: "")
            }}</span>
        </div>
        <div class="contract-information-items">
          <p>Prazo de contratación (en meses):</p>
          <span>
            {{
            (extensionContractTermMonths ? extensionContractTermMonths : "") +
            (extensionContractTermMonths && maintenanceContractTermMonths ? ", " : "") +
            (maintenanceContractTermMonths ? maintenanceContractTermMonths : "") +
            ((extensionContractTermMonths || maintenanceContractTermMonths) && partContractTermMonths? ", " : "") +
            (partContractTermMonths? partContractTermMonths: "")
            }}
          </span>
        </div>
        @if (verifyingOverTwelveMonths) {
        <div class="contract-information-items">
          <p>Fecha de suscripción:</p> <span>{{ formattingDate(subscriptionDate) }} </span>
        </div>
        }
        @if (verifyingOverTwelveMonths) {
        <div class="contract-information-items">
          <p>Precio del Servicio:</p> <span>{{ servicePrice | currency : 'ARS' : '$ ' : '1.2-2' : 'en-US' }} </span>
        </div>
        }
      </div>

      <div>

        <ol class="p-col-11 p-md-11 p-lg-10 editing-list">
          <li class="editing-list-item">

            Sobre las bases de los presentes términos y condiciones el CLIENTE solicita a {{ nameDealership }}
            (en adelante, el "Concesionario Vendedor") el servicio FORD PROTECT para vehículos
            <span *ngIf="!verifyingOverTwelveMonths"> O (cero) KM </span> <span *ngIf="verifyingOverTwelveMonths">
              usados
            </span>(en adelante, denominado el "SERVICIO").
          </li>
          <li class="editing-list-item">
            <b>OBJETO</b>
            <p>
              El SERVICIO será brindado por el Concesionario Vendedor y por cualquier otro concesionario oficial Ford de
              la
              República Argentina (en adelante, "la Red Oficial"), conforme se indica a continuación. El SERVICIO
              incluye:
            </p>
          </li>
          <ol class="custom-list-roman">
            <li class="li-roman">
              <b>FORD ASSISTANCE PLUS:</b> Es el servicio de asistencia de emergencia en ruta al cual se puede recurrir
              durante las 24hs.
              del día los 365 días del año (Servicio Ford Assistance), más el beneficio adicional del traslado de su
              vehículo hasta el
              concesionario que elija el CLIENTE o el más cercano a su domicilio, a su elección.
            </li>
            <li class="li-roman">
              <b>REVISION PREVENTIVA Y RELLENADO DE FLUIDOS:</b> El servicio incluye <b>UNA (1)</b> revisión preventiva
              de
              su vehículo con
              rellenado de fluidos (excepto combustible), desde la adquisición del presente SERVICIO hasta su primer
              servicio de
              mantenimiento programado. Luego, usted podrá solicitar la revisión preventiva que se indica anteriormente,
              entre los
              servicios de mantenimiento programados y recomendados por el fabricante en el Manual del Usuario del
              vehículo. Se aclara
              que dicha revisión, solo podrá ser realizada en las instalaciones del concesionario vendedor del presente
              Servicio.
              La revisión preventiva de su VEHICULO incluye:

              <div class="style-sub-items">

                <p class="style-sub-items-title"> Revisión de niveles y rellenado, en caso de ser necesario de los
                  siguientes fluidos:</p>
                <p class="style-sub-items-text"> - Aceite de Motor</p>
                <p class="style-sub-items-text"> - Líquido de frenos</p>
                <p class="style-sub-items-text"> - Líquido de servodirección</p>
                <p class="style-sub-items-text"> - Líquido de enfriamiento</p>
                <p class="style-sub-items-text"> - Líquido de Limpiaparabrisas</p>
              </div>

              <div class="style-sub-items">
                <p class="style-sub-items-title">Las operaciones de control y revisión preventiva del VEHICULO son:</p>
                <p class="style-sub-items-text">- Luces exteriores e interiores. Panel de Instrumentos </p>
                <p class="style-sub-items-text">- Lava /Limpia parabrisas. Lava luneta </p>
                <p class="style-sub-items-text">- Comandos de A/A y calefacción </p>
                <p class="style-sub-items-text">- Estado general de la Carrocería </p>
                <p class="style-sub-items-text">- Motor, caja de cambios, eje trasero y delantero, caja de transferencia
                </p>
                <p class="style-sub-items-text">- Batería, cableado, tuberías, circuitos de aceite, combustible y
                  refrigerante </p>
                <p class="style-sub-items-text">- Correas de alternador y correa de accesorios </p>
                <p class="style-sub-items-text">- Extremos dirección, precaps, bujes, bieletas y rótulas. </p>
                <p class="style-sub-items-text">- Amortiguadores y componentes de la suspensión. </p>
                <p class="style-sub-items-text">- Estado general de Neumáticos.</p>
              </div>
            </li>
            <li class="li-roman">
              <b>REVISION PERMANENTE DE SU VEHICULO:</b> Servicio de revisión permanente a requerimiento del Cliente, y
              eventual reparación de cualquier defecto de fabricación que pudiera tener el vehículo,<u> una vez vencida
                la
                garantía otorgada por el fabricante</u>. Este servicio podrá efectuarse en cualquier concesionario
              oficial
              de la
              red Ford de la República Argentina.

              <p>
                El SERVICIO, es transferible automáticamente con la venta del vehículo al nuevo propietario. Se deja
                expresa
                constancia que el SERVICIO se presta únicamente en la República Argentina y países limítrofes.
              </p>
            </li>
          </ol>

          <li class="editing-list-item">

            <b> VIGENCIA DEL SERVICIO </b>
            <p>
              El plazo de prestación del SERVICIO será desde el día DD/MM/AA hasta el día DD/MM/AA inclusive, fecha en
              que
              operara su vencimiento. Los términos y condiciones del presente SERVICIO se considerarán aceptados por el
              concesionario vendedor con la facturación del presente SERVICIO al CLIENTE. El SERVICIO no suprime, ni
              reemplaza los derechos del CLIENTE contenidos en la normativa vigente.
            </p>
          </li>
          <li class="editing-list-item">

            <b>CONDICION PARA LA PRESTACION DEL SERVICIO. CONTROL. USO RESPONSABLE. EXCEPCIONES </b>
            <p>

              Como condición para la prestación del SERVICO el CLIENTE deberá acreditar el cumplimiento de los servicios
              de mantenimiento programados, exhibiendo el manual del usuario o las facturas de la Red Oficial o talleres
              QUICK LANE habilitados, o bien presentando copia de las órdenes de reparación emitidas por los
              concesionarios. La prestación del servicio FORD ASSISTANCE Plus, queda exceptuada del control previo que
              se
              indica precedentemente.
            </p>
            <p>
              Se aclara que El SERVICIO no incluye reparaciones por daños accidentales, uso incorrecto, negligencia, o
              vehículos que no hayan sido atendidos exclusivamente por los concesionarios Oficiales Ford o talleres
              QUICK
              LANE. Así mismo se aclara que el SERVICIO caducará automáticamente si los componentes del vehículo fueren
              modificados o utilizados en situaciones no previstas por el fabricante del vehículo.
            </p>
            <p>
              El presente SERVICO no incluye la reparación de piezas que deban ser sustituidas como consecuencia de su
              desgaste normal, ni aquellas que deban ser sustituidas en los mantenimientos programados y recomendados en
              el Manual del Usuario, ni en los servicios de revisión preventiva del VEHICULO. En tales casos, las piezas
              deberán ser reemplazadas a cargo del CLIENTE, siguiendo las recomendaciones del fabricante del vehículo.
              La
              garantía cubre única y exclusivamente defectos de material o manufactura. El desgaste natural por el uso
              no
              está cubierto por el Servicio Ford Protect. Las piezas que tienen desgaste normal por el uso y/o que deben
              ser reemplazadas periódicamente en los servicios de mantenimiento programados y sugeridos por el
              fabricante
              a modo de ejemplo son: neumáticos, correas de dirección, de distribución, baterías, discos y pastillas de
              frenos, amortiguadores, material de fricción de embrague, lámparas, filtros, fusibles, escobillas y
              líquido
              limpiaparabrisas, líquido de frenos, aceites y lubricantes, etc. Los periodos de tiempo o kilometraje para
              las
              piezas de mantenimiento normal con garantía limitada se encuentran detallados en el manual de garantía de
              la
              unidad.
            </p>
          </li>
          <li class="editing-list-item">

            <b>OBLIGACIONES DEL CLIENTE</b>
            <p>

              EL CLIENTE deberá realizar a su cargo, todos los servicios de mantenimiento programado de su VEHICULO de
              acuerdo a las frecuencias y kilometraje indicados en el "Manual del Usuario". Le recordamos efectuar
              chequeos frecuentes y regulares de su VEHICULO. Se deja expresa constancia, que los servicios de
              Mantenimiento programado del VEHICULO, solo podrán efectuarse en los concesionarios oficiales de la Red
              Ford
              o en talleres QUICK LANE habilitados. El CLIENTE declara haber leído y aceptado en su totalidad los
              términos
              y condiciones del presente SERVICIO.
            </p>
          </li>
          <li class="editing-list-item">
            <b>LEGISLACION Y JURISDICCION</b>
            <p>
              Las Partes acuerdan someterse a la legislación de la República Argentina y a la Jurisdicción y competencia
              de Capital Federal, Ciudad Autónoma de Buenos Aires; para todas las cuestiones litigiosas que se susciten
              en
              relación con la interpretación, ejecución y cumplimiento del SERVICIO, renunciando a cualquier otro fuero
              que les pudiera corresponder.
            </p>
          </li>
        </ol>

      </div>

      <div class="col-12 md:col-12 lg:col-11 button-position">
        <button id="btnReturn" class="btn-return" type="button" (click)="buttonComeBack()" [disabled]="blockedUi">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
          <span class="btn-return-span">{{ 'TRANSLATE.RETURN' | translate }}</span>
        </button>
        <button id="btnSave" class="btn-save" type="submit" (click)="saveContractButton()" [disabled]="blockedUi"
          [attr.aria-busy]="blockedUi">
          @if (!blockedUi) {
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
          }
          @if (blockedUi) {
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          <span class="btn-save-span">{{ (blockedUi ? 'TRANSLATE.FINISHING' : 'TRANSLATE.FINALIZE') | translate
            }}</span>
        </button>
      </div>
    </div>
  </div><!-- /.contract-wrapper -->
</div>
}